module.exports = __webpack_public_path__ + "static/img/attention.34a67e49.png";